import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Trophy } from "@phosphor-icons/react";

/**
 * ResultsCTA — rendered immediately after calculator / goal lab outputs.
 *
 * Shows the single most-important projected number big and gold, then
 * a strong "Book a strategy session with Leon" button underneath.
 *
 * Keeps the user one tap away from a reservation without leaving the page.
 */
export default function ResultsCTA({
  testid = "results-cta",
  heroLabel = "Your projected outcome",
  heroValue,
  heroSuffix,
  subline,
  ctaLabel = "Ready to make this real? Book a strategy session with Leon.",
  ctaHref = "/reserve",
  secondaryHref,
  secondaryLabel,
}) {
  return (
    <div
      data-testid={testid}
      className="relative mt-10 border border-exodus-gold bg-exodus-elevated p-8 md:p-10"
    >
      <div className="absolute top-0 left-0 w-16 h-1 bg-exodus-gold" />
      <div className="flex items-start justify-between gap-6 flex-wrap">
        <div className="min-w-0 flex-1">
          <p className="eyebrow flex items-center gap-2">
            <Trophy size={14} weight="fill" className="text-exodus-gold" /> {heroLabel}
          </p>
          <p className="font-display text-5xl md:text-6xl gold-text mt-3 leading-none break-words">
            {heroValue}
            {heroSuffix && (
              <span className="text-xl md:text-2xl text-exodus-muted ml-2 font-normal">
                {heroSuffix}
              </span>
            )}
          </p>
          {subline && (
            <p className="text-sm text-exodus-muted mt-3 max-w-xl">{subline}</p>
          )}
        </div>
      </div>

      <div className="mt-8 border-t border-exodus-border pt-6 flex flex-wrap items-center gap-4">
        <Link
          to={ctaHref}
          data-testid={`${testid}-primary`}
          className="btn-gold inline-flex items-center gap-2"
        >
          {ctaLabel} <ArrowRight size={16} weight="bold" />
        </Link>
        {secondaryHref && secondaryLabel && (
          <Link
            to={secondaryHref}
            data-testid={`${testid}-secondary`}
            className="btn-ghost text-sm"
          >
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  );
}
